<template>
    <div class="ion-page">
        <ion-header class="rp-mobile">
            <ion-toolbar class="mobile-header-toolbar">
                <ion-buttons slot="start">
                <ion-menu-button></ion-menu-button>
                </ion-buttons>
                <ion-title>Log</ion-title>
            </ion-toolbar>
        </ion-header>
        <ion-header class="rp-desktop">
            <ion-toolbar>
                <ion-buttons slot="start">
                <ion-menu-button></ion-menu-button>
                </ion-buttons>
                <ion-title>Log</ion-title>
            </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
            <!-- <div class="page ion-margin">
                <div v-html=compiledHtml></div>
            </div> -->
            <div>
                <ion-grid>
                <ion-row v-for="(data, index) in input" :key="index" :class="{'evenRow' : index % 2 === 0, 'oddRow' : index % 2 !== 0}">
                    <ion-col size="12" size-md="6" >{{index +". " +data}}</ion-col>
                    <ion-col size="4" size-md="3" class="col-padding" >
                    <ion-button class="btn-download" @click="downloadLogFile(data)">
                        <ion-icon name="download"></ion-icon>Download
                    </ion-button>
                    </ion-col>
                    <ion-col size="4" size-md="3" class="col-padding">
                    <ion-button class="btn-download" @click="readSelectedLog(data)">
                        <ion-icon name="book"></ion-icon><label>Read</label>
                    </ion-button>
                    </ion-col>
                </ion-row>
                <ion-row v-if="selectedFile">
                    <ion-col>
                    <div class="page ion-margin" id="convertToHtml">
                        <div v-html=compiledHtml></div>
                        <!-- <div><p>{{selectedFile}}</p></div> -->
                    </div>
                    </ion-col>
                </ion-row>
                </ion-grid>
            </div>
        </ion-content>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import axios from 'axios'
import { config } from "../../config";
import { LocalStorage } from "../../data/localstorage";

export default defineComponent ({
    name: 'log',
    data() {
        return {
            fileName: "log.html",
            input: "",
            selectedFile: "",
            link: "iisnode/"
        }
    },
    created() {
        this.fileName = config.api.host +"/log/getApiLogs";
        this.loadFile();
    },
    computed: {
        compiledHtml: function() {
        return this.selectedFile;
        }
    },
    methods: {
        loadFile() {
        axios({
            method: "get",
            url: this.fileName
        })
            .then(result => {
            this.input = result.data.data;
            // this.link = result.data.link;
            // var parser = new DOMParser();
            // var doc = parser.parseFromString(result.data, 'text/html');
            // this.input = doc.body;
            })
            .catch(error => {
            console.error("error getting file");
            });
        },
        async openLogFile(file) {
        axios.get(config.api.host +"log/getSelectedLogFile",{
            data: file
        },{
            headers: {
                    Authorization: new LocalStorage().authToken
                }
        }).then((res) => {
            this.selectedFile = res.data;
        }).catch((error) => {
            console.error(error.message);
        })
        },
        downloadLogFile(file) {
        const URL = file;
        axios({
            url : config.api.host+"/"+this.link+file,
            method: 'GET',
            responseType: 'blob'
        }).then((response) => {
            var fileurl = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement("a");
            fileLink.href = fileurl;
            fileLink.setAttribute("download", file);
            document.body.appendChild(fileLink);
            fileLink.click();
        })
        // var a = document.createElement("a");
        // alert(config.api.host+"/"+this.link+file);
        // a.href = config.api.host+"/"+this.link+file;
        // a.setAttribute("download", file+".txt");
        // document.body.appendChild(a);
        // a.click();
        // a.remove();
        },
        async readSelectedLog(logFile) {
        this.selectedFile = "";
        axios({
            url : config.api.host+"/"+this.link+logFile,
            method: 'GET'
        }).then((res) => {
            this.selectedFile = res.data;
            this.selectedFile = $('div').text(this.selectedFile).html();
            // let arr = res.data;
            // let split = arr.split('n');
            // split.map(i => JSON.parse(i));
            // console.log(split);
        }).catch((error) => {
            console.error(error.message);
        })
        }
    }
})
</script>

<style scoped>
.page {
  word-wrap: initial;
}
.evenRow {
  background: rgb(245, 244, 244);
}
.oddRow {
  background-color: white;
}
@media (max-width: 768px) {
  .mobile-header-toolbar {
    --background: #21b24b;
  }
  .mobile-header-toolbar {
    height: 56px;
    padding-top: 1px;
  }
  .mobile-header-toolbar ion-title {
    color: #ffffff;
  }
  .mobile-header-toolbar ion-buttons {
    color: #ffffff;
    --background: #ffffff;
  }
  .mobile-header-toolbar ion-menu-button {
    color: #ffffff;
    margin-right: 13px;
  }
}
</style>